import { useTranslation } from 'react-i18next';
import { CardV2 } from "../../../components/CardV2/CardV2";
import { DraggableList } from "../../../components/DraggableList/DraggableList";

interface TermsConditionsSectionProps {
  contractTemplate: any;
  updateContractTemplate: (value: any) => void;
}

export default function TermsConditionsSection({ contractTemplate, updateContractTemplate }: TermsConditionsSectionProps) {
  const { t } = useTranslation();

  return (
    <CardV2>
      <div className="p-4">
        <div className="text-xs text-muted-foreground mb-4">
          {t('commission_contract_template.contract_conditions_hint') || 'These are the detailed conditions that will appear in the final contract when brides sign it.'}
        </div>
        <DraggableList
          items={contractTemplate.conditions || []}
          setItems={items => updateContractTemplate({ conditions: items })}
          placeholder={t('commission_contract_template.contract_conditions.placeholder') || 'Add a contract condition...'}
          buttonText={t('commission_contract_template.contract_conditions.add_button') || 'Add condition'}
        />
      </div>
    </CardV2>
  );
}
